import React from 'react';
import { useTranslation } from 'react-i18next';
import ManageRoleModal from '../Modal/ManageRoleModal';
import AvailableRoleDragADrop from './AvailableRoleDragADrop';
import ChooseRole from './ChooseRoleDragADrop';
import HeadTittle from '../../../../../components/HeadTittle';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { CustomTextField } from '../../../../../components/CustomTextField';
import CustomListContainer from '../../../../../components/CustomListContainer';
import CustomCardContainer from '../../../../../components/CustomCardContainer';
import ButtonSubAction from '../../../../../components/buttons/ButtonSubAction';
import { DroppableContainer } from './DroppableContainer';
import FunctionalityCreateNewRole from '../Functionality/CreateNewRole';
import routes from '../../../../../Routes/routes';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';
import DividerWithText from '../../../../../components/DividerWithText';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { EditIcon, PlusIconsOptions } from '../../../../../components/buttons/IconButtons';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const CreateNewRole = () => {
    const { t } = useTranslation();
    const {
        clearField,
        handleNameChange,
        roleName,
        submitClicked,
        handleTaskListClick,
        handleDropAvailable,
        handleDropChoosed,
        roleListData,
        mobileAvailableList,
        setMobileAvaliableList,
        websiteAvailableList,
        setWebsiteAvailableList,
        mobileChooseList,
        setMobileChooseList,
        websiteChooseList,
        setWebsiteChooseList,
        mobileSelected,
        setMobileSelected,
        websiteSelected,
        setWebsiteSelected,
        handleCreateRole,
        id,
        readOnly
    } = FunctionalityCreateNewRole();
    return (
        <>
            <HeadTittle
                name={
                    id
                        ? !readOnly
                            ? t('update')
                            : t('details')
                        : t('create')
                }
                onBack={routes.roles.list}
            >
                {!readOnly &&
                    <ButtonAction
                        id='btn_cnr_create_or_update'
                        name={id ? t('update') : t('create')}
                        className='btn-icon-add px-4 w-100'
                        onClick={() => handleCreateRole()}
                        Icon={id ? EditIcon : PlusIconsOptions}
                    />
                }
            </HeadTittle>{' '}
            <div className='row'>
                <div className='row'>
                    <div className={'col-12'}>
                        <DividerWithText title={t('permissions')} />
                    </div>
                    <div className='d-flex justify-content-end col-12 mb-2'>
                    {!id && (
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_cnr_clean'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            iconProps={'btn-icon-svg-12px icon-color-general-00'}
                            onClick={() => {
                                clearField();
                            }}
                        />)}
                    </div>
                    <div className='w-50'>
                        <CustomTextField
                            id='txt_cnr_privilege'
                            trans='privilege_name'
                            onChange={handleNameChange}
                            value={roleName}
                            required={true}
                            emptyFields={submitClicked && (!roleName || roleName.trim() === '')}
                            type='text'
                            disabled={readOnly}
                        />
                    </div>
                </div>
            </div>
            <div className='create_new_role'>
                <div className='row'>
                    <div className='row'>
                        {!readOnly &&
                            <div className='col-6'>
                                <CustomCardContainer
                                    title={'available'}
                                    cardActionsClass='background-grey'
                                    cardContentClass={'h-500px'}
                                    actions={
                                        <ButtonSubAction
                                            id='btn_cnr_add'
                                            name='add_all'
                                            onClick={() =>
                                                handleTaskListClick({
                                                    check: 5,
                                                })
                                            }
                                        />
                                    }
                                >
                                    <CustomListContainer>
                                        <DroppableContainer onDrop={handleDropAvailable} accepts='box'>
                                            <div className='new_role_available_container'>
                                                <AvailableRoleDragADrop
                                                    onHandler={handleTaskListClick}
                                                    data={roleListData}
                                                    mobileAvailableList={mobileAvailableList}
                                                    setMobileAvailableList={setMobileAvaliableList}
                                                    websiteAvailableList={websiteAvailableList}
                                                    setWebsiteAvailableList={setWebsiteAvailableList}
                                                    mobileChooseList={mobileChooseList}
                                                    setMobileChooseList={setMobileChooseList}
                                                    websiteChooseList={websiteChooseList}
                                                    setWebsiteChooseList={setWebsiteChooseList}
                                                    mobileSelected={mobileSelected}
                                                    setMobileSelected={setMobileSelected}
                                                    websiteSelected={websiteSelected}
                                                    setWebsiteSelected={setWebsiteSelected}
                                                />
                                            </div>
                                        </DroppableContainer>
                                    </CustomListContainer>
                                </CustomCardContainer>
                            </div>
                        }

                        <div className='col-6'>
                            <CustomCardContainer
                                title={'choosed'}
                                cardActionsClass='background-grey'
                                cardContentClass={'h-500px'}
                                actions={
                                    !readOnly &&
                                    <ButtonSubAction
                                        id='btn_cnr_remove'
                                        name='remove_all'
                                        onClick={() => handleTaskListClick({ check: 6 })}
                                    />
                                }
                            >
                                <CustomListContainer>
                                    <DroppableContainer onDrop={handleDropChoosed} accepts='box'>
                                        <div className='new_role_available_container'>
                                            <ChooseRole
                                                onHandler={handleTaskListClick}
                                                data={roleListData}
                                                mobileAvailableList={mobileAvailableList}
                                                setMobileAvailableList={setMobileAvaliableList}
                                                websiteAvailableList={websiteAvailableList}
                                                setWebsiteAvailableList={setWebsiteAvailableList}
                                                mobileChooseList={mobileChooseList}
                                                setMobileChooseList={setMobileChooseList}
                                                websiteChooseList={websiteChooseList}
                                                setWebsiteChooseList={setWebsiteChooseList}
                                                mobileSelected={mobileSelected}
                                                setMobileSelected={setMobileSelected}
                                                websiteSelected={websiteSelected}
                                                setWebsiteSelected={setWebsiteSelected}
                                                readOnly={readOnly}
                                            />
                                        </div>
                                    </DroppableContainer>
                                </CustomListContainer>
                            </CustomCardContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateNewRole;
